import { useCopiedState } from "../../../../core/util/hooks";
import { setFilter, removeFilter, initialState, resetOrderIndIdices } from "../orderIndUXSlice";
import { invalidateorderInd } from "../orderIndDataReducer"
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";
import { OrderIndFilter } from "../types";
import { loadAllOrderInd } from "../thunks/loadAllOrderInd";

export const useOrderIndFilter = () => {
	const storeFilter = useSelector<StoreType, OrderIndFilter>(store => store.ux.trading.orderInd.filter);
	const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<OrderIndFilter>(storeFilter);

	const dispatch = useDispatch();
	const dispatchSetFilter = React.useCallback(() => {
		dispatch(setFilter(filter!));
		dispatch(resetOrderIndIdices());
		dispatch(invalidateorderInd());
		dispatch(loadAllOrderInd());
	}, [dispatch, filter]);

	const dispatchResetFilter = React.useCallback(() => {
		setCurrentFilter(initialState.filter);

		dispatch(setFilter(initialState.filter));
		dispatch(resetOrderIndIdices());
		dispatch(invalidateorderInd());
		dispatch(loadAllOrderInd());

	}, [setCurrentFilter, dispatch])

	return [
		filter,
		editFilter,
		dispatchSetFilter,
		changeState,
		dispatchResetFilter
	] as [
			typeof filter,
			typeof editFilter,
			typeof dispatchSetFilter,
			typeof changeState,
			typeof dispatchResetFilter
		]
};

export const useCurrentOrderIndFilter = () => {
	const filter = useSelector<StoreType, OrderIndFilter>(store => store.ux.trading.orderInd.filter);
	const dispatch = useDispatch();
	const dispatchRemoveFilter = React.useCallback(
		(type: keyof OrderIndFilter) => {

			const newFilter = { ...filter };

			delete newFilter[type];

			dispatch(setFilter(newFilter));
			dispatch(resetOrderIndIdices());
			dispatch(invalidateorderInd());
			dispatch(loadAllOrderInd());
		},
		[dispatch, filter]
	);

	return [filter, dispatchRemoveFilter] as [typeof filter, typeof dispatchRemoveFilter];
};
